import React, {useEffect, useState} from 'react';
import localStrings from "../../localStrings";
import PageWithTitle from "../../components/pages/pageWithTitle";
import useAuth from "../../hooks/useAuth";
import {filterSingleDay} from "../Home/FilterInfoOverview";
import CenterMessage from "../../components/messages/CenterMessage";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import moment from "moment";
import { frFR } from '@mui/x-data-grid/locales';
import { frFR as pickersFrFR } from '@mui/x-date-pickers/locales';
import { frFR as coreFrFR } from '@mui/material/locale';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import {Box, Tab, Tabs, Typography} from "@mui/material";
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import {getUriSetting, saveUriSetting, SELECTED_TAB} from "../../utils/optionsUriLocalStorage";
import BrandCreateUpdateForm from "../Brands/AccountCreateUpdateView/BrandCreateUpdateForm";
import BrandUsers from "../Brands/AccountCreateUpdateView/brandUsers";
import DetailGridView from "./DetailGridView";
import SummaryGridView from "./SummaryGridView";

// Crée un thème MUI par défaut
export const dataGridTheme = createTheme(
    {
        palette: {
            primary: { main: '#1976d2' },
        },
    },
    frFR, // x-data-grid translations
    pickersFrFR, // x-date-pickers translations
    coreFrFR, // core translations
);



const AccountingView = () => {

    const searchParams = new URLSearchParams(window.location.search);
    const tab = searchParams.get('tab');

    const [currentTab, setCurrentTab] = useState(tab || getUriSetting(SELECTED_TAB) || 'detail');
    const handleTabsChange = (event, value) => {
        saveUriSetting(SELECTED_TAB, value)
        setCurrentTab(value);
    };
    //
    // const pivotModel = {
    //     rows: [
    //         { field: 'staff_name' },
    //         { field: 'location' },
    //         // { field: 'size' }
    //     ],
    //     columns: [
    //         { field: 'location' },
    //         { field: 'staff_name' },
    //     ],
    //     values: [
    //         { field: 'totalWithTaxRaw', aggFunc: 'sum' },
    //         // { field: 'totalWithTaxRaw', aggFunc: 'avg' },
    //     ],
    // };




    // const [orders, setOrders] = React.useState(null);

    function getMainButtons() {
        return null;
    }



    const initialState = {
        pivoting: {
            enabled: true,
            // model: pivotModel,
            panelOpen: true,
        },
    };

    return (


        <PageWithTitle mainButtons={getMainButtons()}>

            <Tabs
                onChange={handleTabsChange}
                scrollButtons="auto"
                value={currentTab}
                textColor="secondary"
                variant="scrollable"
            >
                <Tab label={localStrings.detail} value="detail" />
                <Tab label={localStrings.summary} value="summary" />
            </Tabs>
            {currentTab === 'detail' &&  <DetailGridView/>}
            {/*{currentTab === 'chargeAccount' &&  <SelectAmountToPay/>}*/}
            {/*{currentTab === 'paymentList' &&  <PaymentList/>}*/}
            {/*{currentTab === 'chargeHistory' &&  <ChargeHistory/>}*/}
            {currentTab === 'summary' &&  <SummaryGridView/>}

        </PageWithTitle>

    );
};

export default AccountingView;